// @flow
import * as React from 'react';
import { Icon, Button } from 'components/atoms/';
import { Modal, Container, Row, Col } from 'reactstrap';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

import CreateProfileContent from './components/CreateProfileContent/';

// Utils
import { clickEvent } from 'utils/adaConfigurations/customEvents';
import { captureFocusUtilities } from 'utils/adaConfigurations/ModalFocusPrision';
import './CreateProfile.scss';

type Props = {
  intl: IntlShape
};

type State = {
  /**
   * True if the modal is opened
   */
  isOpen: boolean
};

class CreateProfile extends React.Component<Props, State> {
  static block = 'create-profile';

  constructor() {
    super();
    (this: any).modalContainer = React.createRef();
    (this: any).captureUtilities = captureFocusUtilities();
  }
  state = {
    isOpen: false
  };

  componentDidUpdate() {
    if (this.state.isOpen) {
      (this: any).captureUtilities.capture((this: any).modalContainer.current);
    } else {
      (this: any).captureUtilities.free();
    }
  }

  componentWillUnmount() {
    (this: any).captureUtilities.free();
  }

  modalContainer: React.Ref<any>;
  /**
   * Toggles the open state of the modal
   */
  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { intl } = this.props;
    const ns = CreateProfile.block;
    return (
      <Container className={ns}>
        <Modal
          className={`${ns}__modal`}
          toggle={this.toggle}
          isOpen={this.state.isOpen}
          zIndex={6666}
          fade={true}
        >
          <div className={`${ns}__modal-body`} ref={this.modalContainer}>
            <div className={`${ns}__close`}>
              <Icon
                className={`${ns}__close-icon`}
                type="close"
                onClick={this.toggle}
                aria-label={intl.formatMessage({
                  id: 'c8.aria.close.create.profile.modal',
                  defaultMessage: 'Close Create Profile Modal'
                })}
                tabIndex={0}
                onKeyUp={clickEvent}
              />
            </div>
            <div className={`${ns}__modal-content`}>
              <CreateProfileContent />
            </div>
          </div>
        </Modal>

        <Row>
          <Col
            md={{ size: 6, offset: 3 }}
            className={`${ns}__trigger-content`}
            onClick={this.toggle}
          >
            <span className={`${ns}__trigger-label-left`}>
              {intl.formatMessage({
                id: 'c8.confirmation.save.time.on.your.next.visit'
              })}
            </span>
            <span className={`${ns}__trigger-label-right`}>
              <Button
                buttonTheme="link"
                className={'indexed'}
                tabIndex={0}
                aria-label={intl.formatMessage({
                  id: 'c8.aria.common.create.profile',
                  defaultMessage: 'Create User Profile'
                })}
              >
                {intl.formatMessage({ id: 'c8.common.create.profile' })}
              </Button>
            </span>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default injectIntl(CreateProfile);



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/CreateProfile.js